// extracted by mini-css-extract-plugin
export default {"buzzwordList":"styles_buzzwordList__KIx4k"};